import { useTheme } from "@mui/material/styles";

const useProductCardStyles = ({ height, mobileWidth, webWidth, tabWidth, fullWidth }) => {
  const theme = useTheme();

  return {
    card: {
      minHeight: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: { xs: "flex-start", md: "space-between" },
      flex: fullWidth ? 1 : {
        xs: mobileWidth,
        md: tabWidth,
        lg: webWidth,
      },
      maxWidth: fullWidth ? "100%" : {
        xs: "calc(83% + 16px)",
        md: "calc(86% + 16px)",
        lg: "calc(89% + 16px)",
      },
      position: "relative",
      height: height,
      cursor: "pointer",
    },
    imageContainer: {
      position: "relative",
      overflow: "hidden",
    },
    image: {
      maxHeight: "100%",
      width: "100%",
      height: "auto",
      objectFit: "cover",
    },
    image1: {  
      width: "100%",
      aspectRatio: '295 / 390',
      objectFit: "cover",
    },
    arrowButton: {
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      color: "#0F0F0F",
      width: "16px",
      height: "16px",
      zIndex: 1,

      "&.arrow-left": {
        left: "8px",
      },
      "&.arrow-right": {
        right: "8px",
      },
    },
    arrowIcon: {
      width: "20px",
      height: "20px",
      fontSize: "20px",
    },
    dotsContainer: {
      position: "absolute",
      bottom: "12px",
      left: "50%",
      transform: "translateX(-50%)",
      display: "flex",
      gap: "0px",
      alignItems: "center",
      width: "120px",
      justifyContent: "space-between",
    },
    dot: {
      width: "20px",
      height: "3px",
      borderRadius: "2px",
      backgroundColor: "rgba(255, 255, 255, 0.6)",
      cursor: "pointer",
      transition: "all 0.3s ease",
      "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.8)",
      },
    },
    activeDot: {
      backgroundColor: "#000",
      width: "30px",
      height: "3px",
    },
    detailsWrapper: {
      marginTop: "8px",
      display: "flex",
      flexDirection: "column",
      gap: "4px",
    },
    title: {
      fontFamily: "Lexend",
      fontSize: { xs: "12px", sm: "14px" },
      fontWeight: 400,
      lineHeight: { xs: "15px", sm: "17.5px" },
      color: theme.palette.customColor.secondarySecond,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      maxWidth: { md: "35ch", xs: "20ch" },
    },
    subtitle: {
      fontFamily: "Belleza",
      fontSize: { xs: "18px", sm: "24px" },
      fontWeight: 400,
      lineHeight: { xs: "20.74px", sm: "27.65px" },
      textUnderlinePosition: "from-font",
      textDecorationSkipInk: "none",
      color: theme.palette.primary.main,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      maxWidth: "25ch",
    },    
    footer: {
      marginTop: "16px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    price: {
      fontFamily: "Lexend",
      fontSize: { xs: "14px", sm: "16px" },
      fontWeight: 500,
      lineHeight: { xs: "18px", sm: "20px" },
      color: theme.palette.primary.main,
    },
    iconBackground:{
      color: `${theme.palette.secondary.main} !important`,
      borderRadius: "50%",
      px: "10px",
      py: "6px",
    },
    bag: {
      height: "28px",
      width: "28px",
    },
    favIcon: {
      position: "absolute",
      top: { xs: "8px", md: "10px" },
      right: { xs: "8px", md: "10px" },
      padding: "4px",
      zIndex: 2,
    },
    favSelectedIcon: {
      position: "absolute",
      top: { xs: "8px", md: "10px" },
      right: { xs: "8px", md: "10px" },
      color: theme.palette.customColor.red,
      padding: "4px",
      zIndex: 2,
    },
    overlayBox: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      opacity: 1,
      transition: "opacity 0.3s ease",
      backgroundColor: "rgba(0, 0, 0, 0.7)",
      cursor: "not-allowed",
    },
    overlay: {
      backgroundColor: "black",
      color: "white",
      padding: "8px",
      borderRadius: "4px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "not-allowed",
      radius: "0px",

    },
    outOfStock: {
      fontFamily: "Lexend",
      fontSize: "11px",
      fontWeight: 500,
      lineHeight: "100%",
      color: "#F44336",
    }
  };
};

export default useProductCardStyles;
